<template>
  <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
    <template slot="table-body">
      <gestione-attivita-moduli-edit-component @updateJsonData="onUpdateJsonData"></gestione-attivita-moduli-edit-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GestioneAttivitaModuliEditComponent from "../components/GestioneAttivitaModuliEditComponent.vue";
export default {
  components: { GestioneAttivitaModuliEditComponent, SaPageLayout },
  data() {
    return {
      btnSaveVisible: true,
      showModalLoading: false,
      linkback: "/gestioneattivita/moduli",
      pathResource: "/gestioneattivitamoduli",
      jsonData: null,
    };
  },
  methods: {
    onUpdateJsonData(jsonData) {
      this.jsonData = jsonData;
    },
  },
};
</script>

<style></style>
